import * as React from "react";
import NextImage from "next/image";
import { Stack, Box, BoxProps } from "@chakra-ui/react";

import { ReactFCC } from "src/types/types";

const CityHeader: ReactFCC<{ height?: BoxProps["height"] }> = ({
  height,
  children,
}) => (
  <Stack
    h={height || "550px"}
    spacing="0px"
    position="relative"
    align="center"
    justify="center"
    px="10px"
    overflowX="hidden"
  >
    <Box w="1680px" h="500px" position="absolute" bottom="0" zIndex="-10">
      <NextImage
        priority
        alt=""
        src="/img/common/city_scape.svg"
        fill
        style={{ objectFit: "contain" }}
      />
    </Box>
    {children}
  </Stack>
);

export default CityHeader;
